import "./App.css";
import Navbar from "./components/Navbar";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Box } from "@mui/material";
import Home from "./pages/LegacyCode/Home";
// import './App.css'
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import Service from "./pages/LegacyCode/Service";
import Contact from "./pages/LegacyCode/Contact";

import Footer from "./components/footer/Footer";
import { useEffect, useState, useCallback, useContext } from "react";
import Homepage from "./pages/Homepage/Homepage";

import Lottie from "lottie-react";
import animationData from "./util/robot_loader.json";
import Agripage from "./pages/Agripage/Agripage.jsx";
// import Logisticspage from "./pages/Logisticspage/Logisticspage";
import Servicepage from "./pages/Servicepage/Servicepage";
import AboutusPage from "./pages/AboutusPage/AboutusPage";
import SecretPage from "./pages/SecretPage/SecretPage";
import Signup from "./pages/SignupPage/Signup";
import Login from "./pages/LoginPage/Login";
import PhysicalAI from "./pages/Homepage/PhysicalAI/PhysicalAI";
import ProductPage from "./pages/ProductPage/ProductPage";

import { UserContext } from "./context/userContext.js";

function App() {
  const [isLoader, setIsLoader] = useState(true);
  const [loaderDelay, setLoaderDelay] = useState(false);
  useEffect(() => {
    // Setting Loading
    // Setting Load for 2.8 seconds
    setTimeout(() => setLoaderDelay(true), 300);
    setTimeout(() => {
      setIsLoader(false);
    }, 2800);
  }, []);

  const [userContext, setUserContext] = useContext(UserContext);

  const verifyUser = useCallback(() => {
    // Skip API call if endpoint is not configured
    if (!process.env.REACT_APP_API_ENDPOINT) {
      console.log("API endpoint not configured, skipping auth verification");
      return;
    }
    
    // const token = localStorage.getItem("authToken").trim();
    // console.log(token);
    fetch(process.env.REACT_APP_API_ENDPOINT + "users/refreshToken", {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then(async (response) => {
        console.log(response);
        if (response.ok) {
          console.log("here");
          const data = await response.json();
          setUserContext((oldValues) => {
            return { ...oldValues, token: data.token };
          });
        } else {
          console.log("wrong here");
          setUserContext((oldValues) => {
            return { ...oldValues, token: null };
          });
        }
        // call refreshToken every 5 minutes to renew the authentication token.
        setTimeout(verifyUser, 5 * 60 * 1000);
      })
      .catch((error) => {
        console.log("API connection error (this is normal if backend is not running):", error.message);
        // Don't retry if there's a network error
      });
  }, [setUserContext]);

  useEffect(() => {
    verifyUser();
  }, [verifyUser]);
  return (
    <div className="app-container">
      <Router>
        <Navbar />
        {isLoader && (
          <div className="logo_section">
            {loaderDelay && (
              <Lottie
                animationData={animationData}
                loop
                autoplay
                rendererSettings={{
                  preserveAspectRatio: "xMidYMid slice",
                }}
              />
            )}
          </div>
        )}

        {!isLoader && (
          <Box
            className="main-content"
            sx={{
              flex: 1,
              overflowY: 'auto',
              overflowX: 'hidden',
              scrollbarWidth: 'none', // Hide scrollbar in Firefox
              msOverflowStyle: 'none', // Hide scrollbar in IE/Edge
              '&::-webkit-scrollbar': {
                display: 'none', // Hide scrollbar in Webkit browsers
              },
            }}
          >
            <Routes>
              <Route path="/" exact element={<Homepage />} />
              <Route path="/agri-robots" exact element={<Agripage />} />
              {/* <Route path="/logistic-robots" exact element={<Logisticspage />} /> */}
              <Route path="/service-robots" exact element={<Servicepage />} />
              <Route path="/about" exact element={<AboutusPage />} />
              <Route path="/physical-ai" exact element={<PhysicalAI />} />
              <Route path="/products" exact element={<ProductPage />} />
              <Route path="/home" exact element={<Home />} />
              <Route path="/service" exact element={<Service />} />

              <Route path="/contact" exact element={<Contact />} />
              <Route path="/signup" exact element={<Signup />} />
              <Route path="/login" exact element={<Login />} />
              <Route
                path="/secret-page"
                exact
                element={<SecretPage userContext={userContext} />}
              />
            </Routes>
            <Footer />
          </Box>
        )}
      </Router>
    </div>
  );
}

export default App;
